const ITEMS = [
  "AUTOMATED COMPLIANCE",
  "OFFER LETTER ENGINE · CLAUDE",
  "24/7 EMPLOYEE CONCIERGE · CHATGPT",
  "OPERA360 CERTIFIED CURRICULUMS",
  "RETENTION PREDICTION",
  "ZERO-TOLERANCE BIAS AUDITS",
];

const COLORS = ["text-[#FF5722]", "text-[#38BDF8]", "text-[#10B981]", "text-[#EC4899]", "text-[#F59E0B]", "text-[#8B5CF6]"];

export default function EditorialMarquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="py-8 bg-[#0F2440] border-y border-white/10 overflow-hidden" aria-label="Capabilities marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display font-black text-xl sm:text-2xl tracking-tight ${COLORS[i % COLORS.length]}`}>
              {item}
            </span>
            <span className="mx-8 text-slate-600 text-2xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
